const storageKey = "patientId";
const PatientIdStorage = {
  setId: id => sessionStorage.setItem(storageKey, id),
  getId: () => parseInt(sessionStorage.getItem(storageKey)),
  removeId: () => sessionStorage.removeItem(storageKey)
};

export default PatientIdStorage;
